import de from "./de.json";
import fr from "./fr.json";
import en from "./en.json";
import es from "./es.json";
import pt from "./pt.json";

export const I18n = { de, fr, en, es, pt };
